import isEqual from 'lodash/fp/isEqual';

export const areEqual = (prevProps, nextProps) => isEqual(prevProps, nextProps);

export default null;
